import React from 'react';
import AttachmentsPanel from './AttachmentsPanel';

function Documentation({ users, currentUser }) {
  return (
    <div className="fade-in">
      <div className="card">
        <h2>Documents de référence</h2>
        <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 16, marginTop: -8 }}>
          Procédures, modèles et gabarits communs à tous les projets (ex. procédure de nommage des documents).
        </p>
        <AttachmentsPanel
          users={users}
          currentUser={currentUser}
          global
          emptyLabel="Aucun document de référence pour l'instant."
        />
      </div>
    </div>
  );
}

export default Documentation;
